<template>
  <div class="b-screenings">
    <template v-if="desktop">
      <div v-for="(screen, index) in screenings" :key="index">
        <div
          class="b-screenings__el-holding"
          :class="[
            currentSelectedScreen(screen),
            { 'b-screenings__el-holding--disabled': screen.soldoutStatus },
          ]"
          @click="selectRoom(screen)">
          <div
            v-if="showPreBookingPreview"
            class="b-screenings__limited b-screenings__limited--preview">
            <div
              v-if="isReachedForLimitedSeats(screen)"
              class="b-screenings__limited__txt">
              {{ dictionary.limitedSeats }}
            </div>
            <div
              v-if="screen.soldoutStatus"
              class="b-screenings__limited__txt b-screenings__limited__txt--sold-out">
              {{ dictionary.soldOutScreen }}
            </div>
          </div>
          <div class="b-screenings__time">
            {{ getScreenTime(screen.showtime) }}
          </div>
          <div class="b-screenings__room-holder">
            <div class="b-screenings__room-sponsor">
              <img
                v-if="screen.sponsor && screen.sponsor.image"
                :src="screen.sponsor.image"
                :alt="screen.sponsor.title"
                :aria-label="screen.sponsor.title" />
            </div>
            <div class="b-screenings__room-data">
              <div class="b-screenings__room-type">
                <slot name="room-type" :screen="screen"></slot>
              </div>
              <div class="b-screenings__room-name">
                {{ screen.screenName }}
              </div>
            </div>
          </div>
          <div class="b-screenings__features">
            <slot name="screen-features" :screen="screen"></slot>
          </div>
          <div v-if="!showPreBookingPreview" class="b-screenings__limited">
            <div
              v-if="isReachedForLimitedSeats(screen)"
              class="b-screenings__limited__txt">
              {{ dictionary.limitedSeats }}
            </div>
            <div
              v-if="screen.soldoutStatus"
              class="b-screenings__limited__txt b-screenings__limited__txt--sold-out">
              {{ dictionary.soldOutScreen }}
            </div>
          </div>
          <div v-else class="b-calender__screening-btn">
            <slot name="action" :current-screen="screen"></slot>
          </div>
        </div>
      </div>
    </template>
    <div v-else>
      <Swiper
        ref="screenSwiper"
        :navigation="{
          nextEl: '.b-screen__next',
          prevEl: '.b-screen__prev',
        }"
        :pagination="{
          el: '.b-screen__pagination',
          type: 'bullets',
          clickable: true,
        }"
        :space-between="5"
        :breakpoints="screensBreakpoints">
        <SwiperSlide v-for="(screen, index) in screenings" :key="index">
          <div
            class="b-screenings__el-holding"
            :class="[
              currentSelectedScreen(screen),
              { 'b-screenings__el-holding--disabled': screen.soldoutStatus },
            ]"
            @click="selectRoom(screen)">
            <div class="b-screenings__card-header">
              <div class="b-screenings__limited">
                <div
                  v-if="isReachedForLimitedSeats(screen)"
                  class="b-screenings__limited__txt">
                  {{ dictionary.limitedSeats }}
                </div>
                <div
                  v-if="screen.soldoutStatus"
                  class="b-screenings__limited__txt b-screenings__limited__txt--sold-out">
                  {{ dictionary.soldOutScreen }}
                </div>
              </div>
              <div class="b-screenings__time">
                {{ getScreenTime(screen.showtime) }}
              </div>
              <div class="b-screenings__features">
                <slot name="screen-features" :screen="screen"></slot>
              </div>
            </div>
            <div class="b-screenings__card-header">
              <div>
                <div class="b-screenings__room-type">
                  <slot name="room-type" :screen="screen"></slot>
                </div>
                <div class="b-screenings__room-name">
                  {{ screen.screenName }}
                </div>
              </div>
              <div class="b-screenings__room-sponsor">
                <img
                  v-if="screen.sponsor && screen.sponsor.image"
                  :src="screen.sponsor.image"
                  :alt="screen.sponsor.title"
                  :aria-label="screen.sponsor.title" />
              </div>
            </div>
            <div v-if="showPreBookingPreview" class="b-screenings__footer">
              <div class="b-calender__screening-btn">
                <slot name="action" :current-screen="screen"></slot>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <div class="swiper__nav--center">
          <div class="swiper-pagination b-screen__pagination"></div>
        </div>
      </Swiper>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { extractFullTimeFromDate } from '../../lib/date'
import useViewport from '../../features/viewport'
const { desktop } = useViewport()
const screensBreakpoints = {
  175: {
    slidesPerView: 1,
    spaceBetween: 8,
  },
  320: {
    slidesPerView: 1,
    spaceBetween: 8,
  },
  576: {
    slidesPerView: 1.5,
    spaceBetween: 8,
  },
  768: {
    slidesPerView: 1.5,
    spaceBetween: 8,
  },
  992: {
    slidesPerView: 1.5,
    spaceBetween: 8,
  },
  1020: {
    slidesPerView: 2,
    spaceBetween: 8,
  },
  1267: {
    slidesPerView: 2,
    spaceBetween: 8,
  },
  1279: {
    slidesPerView: 7,
    spaceBetween: 8,
  },
}
const props = defineProps({
  screenings: {
    default() {
      return {}
    },
    type: Object,
  },
  selectedScreen: {
    default() {
      return {}
    },
    type: Object,
  },
  showPreBookingPreview: {
    default: false,
    type: Boolean,
  },
})

const emit = defineEmits(['choose-screen'])

const selectRoom = (room) => {
  if (!room.soldoutStatus) {
    emit('choose-screen', room)
  }
}

const currentSelectedScreen = (screen) => {
  return props.selectedScreen.id === screen.id ? 'b-screenings--selected' : ''
}

const isReachedForLimitedSeats = (screen) => {
  return screen.isLimited && !screen.soldoutStatus
}

const getScreenTime = (showtime) => {
  return extractFullTimeFromDate(showtime)
}
</script>
